import { render, staticRenderFns } from "./BaseNumberList.vue?vue&type=template&id=8a9bfdd4&scoped=true&"
import script from "./BaseNumberList.vue?vue&type=script&lang=js&"
export * from "./BaseNumberList.vue?vue&type=script&lang=js&"
import style0 from "./BaseNumberList.vue?vue&type=style&index=0&id=8a9bfdd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9bfdd4",
  null
  
)

export default component.exports